module.exports = __webpack_public_path__ + "img/leftcalf-endomorph-male.98086311.svg";